import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ReactLenis } from "@studio-freight/react-lenis";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <React.StrictMode>
      <ReactLenis root>
        <App />
      </ReactLenis>
    </React.StrictMode>
  </BrowserRouter>
);
reportWebVitals();
